import axios from 'axios';

const defaultObserver = {
  setErrors: (errors) => {
    const isObject = typeof errors === 'object' &&
    !Array.isArray(errors) &&
    errors !== null;

    if (isObject) {
      alert(Object.values(errors));
    } else {
      alert(errors);
    }
  }
};

export const setupAxios = (validationObserver = defaultObserver) => {
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_GHOST,
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const responseHandlerMiddleware = (response) => {
    return response;
  };

  const errorHandlerMiddleware = (error) => {
    //console.log("error.response", error.response)
    const { status } = error.response;
    const { errors } = error.response.data;

    if (status === 422) {
      validationObserver.setErrors(errors);
      return;
    }

    if (status >= 500) {
      alert('Erro ao acessar o servidor. Por favor, tente mais tarde');
    }

    return error.response;
    //throw error;
  };

  axiosInstance.interceptors.response.use(
    responseHandlerMiddleware,
    errorHandlerMiddleware
  );

  return axiosInstance;
};
